import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Tag from '../../ui/Tag';

import CatalogPageLink from '../CatalogPageLink';
import Button from 'react-bootstrap/Button';

import style from './CatalogRowCard.module.scss';
import clsx from 'clsx';

import { useTranslation } from 'react-i18next';
import useReactiveMessage from '../../hook/UseReactiveMessage';
import useYouTubeInfo from "../../hook/UseYouTubeInfo";

const CatalogRowCard = (props) => {

  let {
    title,
    subtitle,
    description,
    catalogImageUrl,
    catalogPageUrl,
    catalogVideoId,
    catalogPreviewImageUrls = [],
    companyName,
    companyLogoUrl,
    companyPageUrl,
    companyContractDisplayId,
    companyId,
    catalogId,
    fileSize,
    tags = [],
    showSearchButton = false,
    disablePreview = false,
  } = props;

  const {t} = useTranslation('catalog');
  const {sendMessage} = useReactiveMessage('CATALOG_PREVIEW');

  // let {
  //   video,
  //   setVideoId,
  // } = useYouTubeInfo(catalogVideoId);

  // useEffect(() => {
  //   setVideoId(catalogVideoId);
  // }, [catalogVideoId]);

  const onClickPreview = () => {
    if (disablePreview) return;
    sendMessage({
      title,
      subtitle,
      description,
      tags,
      catalogPreviewImageUrls,
      catalogPageUrl,
      companyName,
      companyLogoUrl,
      companyPageUrl,
      companyContractDisplayId,
      companyId,
      catalogId,
      fileSize,
    }, 'CATALOG_PREVIEW');
  };

  const onClickDownload = () => {
    sendMessage({
      companyContractDisplayId,
      companyId,
      catalogId,
    }, 'CATALOG_DOWNLOAD_CLUEZ');
  };

  // const onClickVideo = () => {
  //   sendMessage(video, 'CATALOG_VIDEO');
  // };

  return (
    <li className={clsx('product-item','col col-12',style.CatalogRowCard)}>
      <div className={clsx('img','text-center',style.CatalogRowCardImage)} data-mh="mh_01">
        <a onClick={onClickPreview} className="catalogPreview">
          <img className="m_imgShadow lazy loading" src={catalogImageUrl} />
        </a>
        {disablePreview==false &&
        <div className="m_previewBtn">
          <a onClick={onClickPreview} >{t('preview')}</a>
        </div>
        }
      </div>
      <div className={style.CatalogRowCardInfo}>
        <div className="dtl">
          <p className={clsx('ttl',style.CatalogRowCardTitle)}>
            <a target="_blank" className="catalogTitleLink" href={catalogPageUrl}>{title}</a>
          </p>
          <p className={clsx('subTxt',style.CatalogRowCardSubTxt)}><a href={companyPageUrl}>{companyName}</a></p>
          <div className="mb-2">
            {tags.map((tag, index) => <Tag key={index} name={tag}/>)}
          </div>
          <p className={clsx('subTxt',style.CatalogRowCardSubTxt,style.CatalogRowCardDescription)}>{description}</p>
        </div>
        <div className="btn-wrap">
          {/* { catalogVideoId != null &&
          <a className="btn btn-default btn-block btn-lg mb-2 js_modal modal-youtube td-click"
            onClick={onClickVideo}
            data-youtube={catalogVideoId}
          >
            <i className="fa fa-video-camera"></i> 動画を見る
          </a>
          } */}
          <Button size="xl" className={clsx('btn btn-default',style.CatalogRowCardButton)} onClick={onClickPreview} >
            <i className="fa fa-search-plus fa-fw"></i>{t('catalog.previewBtn')}
          </Button>
          <a href="#" className={clsx('btn btn-primary btn-xl text-wrap',style.CatalogRowCardButton)} onClick={onClickDownload} data-company_id={companyId} data-catalog_id={catalogId}>
            <i className="fa fa-download fa-fw"></i>{t('catalog.downloadBtn')}
          </a>
        </div>
      </div>
    </li>
  );
};

CatalogRowCard.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  catalogImageUrl: PropTypes.string,
  catalogPageUrl: PropTypes.string,
  catalogPreviewImageUrls: PropTypes.arrayOf(PropTypes.string),
  companyName: PropTypes.string,
  companyLogoUrl: PropTypes.string,
  companyPageUrl: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  disablePreview: PropTypes.bool
};

export default CatalogRowCard;

